import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { LessonInsightsPage } from '@/app/courses/LessonInsightsPage';
import { courseByIdQuery } from '@/modules/catalog/public';
import { isPeriod } from '@/modules/learning/public';
import { RequirePermission } from '@/modules/identity/public';

/** `$courseId_`: irmã do editor, não filha — o editor não tem <Outlet />. */
export const Route = createFileRoute('/_admin/cursos/$courseId_/aulas/$lessonId')({
  validateSearch: z.object({
    dias: z.coerce.number().refine(isPeriod).optional().catch(undefined),
    aba: z.enum(['geral', 'retencao', 'publico', 'pessoas']).optional().catch(undefined),
  }),
  loader: ({ context, params }) => context.queryClient.prefetchQuery(courseByIdQuery(params.courseId)),
  component: function LessonInsightsRoute() {
    const { courseId, lessonId } = Route.useParams();
    const { dias, aba } = Route.useSearch();
    const navigate = Route.useNavigate();
    return (
      <RequirePermission anyOf={['audiencia.ver']}>
        <LessonInsightsPage
          courseId={courseId}
          lessonId={lessonId}
          days={dias ?? 28}
          tab={aba ?? 'geral'}
          onChange={(next) =>
            void navigate({
              search: (prev) => ({ ...prev, dias: next.days ?? prev.dias, aba: next.tab ?? prev.aba }),
              replace: true,
            })
          }
        />
      </RequirePermission>
    );
  },
});
